export const API_DD_SERVICE_URL = import.meta.env
  .VITE_API_DD_SERVICE_URL as string;
